import {LastLoginDefaultBox} from "./last-login.default.box";

export const LastLoginBox = LastLoginDefaultBox;
